import { captureException } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/judicial')({
  beforeLoad: ({ context: { auth } }) => {
    if (!auth.judicial_admin && import.meta.env.PROD) {
      throw notFound()
    }
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
